import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.timers.js";
import { promiseTimeout, useIntersectionObserver } from '@vueuse/core';
import { debounce } from 'lodash-es';
export default defineComponent({
  name: 'PDFViewerPage',
  props: {
    pdf: {
      type: Object,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    zoomScale: {
      type: Number,
      default: 1
    }
  },
  setup: function setup(props) {
    var isIntersecting = ref(false);
    var container = ref(null);
    var canvas = ref(null);
    var isRendered = ref(false);
    var page = ref(null);
    var currentRenderTask = ref(null);
    var stopIntersection = ref(null);
    onBeforeUnmount(function () {
      var _page$value, _stopIntersection$val;
      (_page$value = page.value) === null || _page$value === void 0 ? void 0 : _page$value.cleanup();
      (_stopIntersection$val = stopIntersection.value) === null || _stopIntersection$val === void 0 ? void 0 : _stopIntersection$val.call(stopIntersection);
    });
    onMounted(function () {
      setTimeout(function () {
        var _useIntersectionObser = useIntersectionObserver(container, onIntersect, {
            threshold: 0
          }),
          stop = _useIntersectionObser.stop;
        stopIntersection.value = stop;
      }, 500);
    });
    watch(isIntersecting, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var _page$value2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!val) {
                _context.next = 8;
                break;
              }
              _context.next = 3;
              return promiseTimeout(250);
            case 3:
              if (isIntersecting.value) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              render();
              _context.next = 10;
              break;
            case 8:
              isRendered.value = false;
              (_page$value2 = page.value) === null || _page$value2 === void 0 ? void 0 : _page$value2.cleanup(true);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    watch(function () {
      return props.zoomScale;
    }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            isRendered.value = false;
            _context2.next = 3;
            return nextTick();
          case 3:
            if (isIntersecting.value) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return");
          case 5:
            // При частом зуме не нужно сразу рендерить
            debouncedRender(true);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    var debouncedRender = debounce(render, 300);
    function render() {
      return _render.apply(this, arguments);
    }
    function _render() {
      _render = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _currentRenderTask$va, _page$value3;
        var force,
          viewport,
          outputScale,
          context,
          transform,
          _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              force = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
              if (!(isRendered.value && !force)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              (_currentRenderTask$va = currentRenderTask.value) === null || _currentRenderTask$va === void 0 ? void 0 : _currentRenderTask$va.cancel();
              (_page$value3 = page.value) === null || _page$value3 === void 0 ? void 0 : _page$value3.cleanup(true);
              _context3.next = 7;
              return props.pdf.getPage(props.page);
            case 7:
              page.value = _context3.sent;
              viewport = page.value.getViewport({
                scale: props.zoomScale
              });
              outputScale = window.devicePixelRatio || 1;
              if (canvas.value) {
                _context3.next = 12;
                break;
              }
              return _context3.abrupt("return");
            case 12:
              context = canvas.value.getContext('2d');
              canvas.value.width = Math.floor(viewport.width * outputScale);
              canvas.value.height = Math.floor(viewport.height * outputScale);
              transform = outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : undefined;
              currentRenderTask.value = page.value.render({
                canvasContext: context,
                transform: transform,
                viewport: viewport,
                background: '#FFFFFF'
              });
              _context3.next = 19;
              return currentRenderTask.value;
            case 19:
              isRendered.value = true;
            case 20:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _render.apply(this, arguments);
    }
    function onIntersect(entries) {
      isIntersecting.value = entries[0].isIntersecting;
    }
    return {
      isRendered: isRendered,
      canvas: canvas,
      isIntersecting: isIntersecting,
      container: container
    };
  }
});